var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDienTim(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12898_70277",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12898_70277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7 12.725L9.85 11.45C9.76667 11.3167 9.65 11.2083 9.5 11.125C9.35 11.0417 9.19167 11 9.025 11H2.475C2.29167 10.5667 2.16667 10.15 2.1 9.75C2.03333 9.35 2 8.93333 2 8.5C2 6.93333 2.525 5.625 3.575 4.575C4.625 3.525 5.93333 3 7.5 3C8.36667 3 9.19167 3.18333 9.975 3.55C10.7583 3.91667 11.4333 4.43333 12 5.1C12.5667 4.43333 13.2417 3.91667 14.025 3.55C14.8083 3.18333 15.6333 3 16.5 3C18.0667 3 19.375 3.525 20.425 4.575C21.475 5.625 22 6.93333 22 8.5C22 8.93333 21.9667 9.35 21.9 9.75C21.8333 10.15 21.7083 10.5667 21.525 11H15.575L13.85 8.45C13.75 8.3 13.6208 8.1875 13.4625 8.1125C13.3042 8.0375 13.1333 8 12.95 8C12.7333 8 12.5458 8.0625 12.3875 8.1875C12.2292 8.3125 12.1167 8.475 12.05 8.675L10.7 12.725ZM12 21.35L10.55 20.05C8.8 18.4833 7.36667 17.1417 6.25 16.025C5.13333 14.9083 4.25833 13.9 3.625 13H8.425L10.15 15.55C10.25 15.7 10.3792 15.8125 10.5375 15.8875C10.6958 15.9625 10.8667 16 11.05 16C11.2667 16 11.4542 15.9375 11.6125 15.8125C11.7708 15.6875 11.8833 15.525 11.95 15.325L13.3 11.25L14.175 12.55C14.2583 12.6833 14.375 12.7917 14.525 12.875C14.675 12.9583 14.8333 13 15 13H20.375C19.7417 13.9 18.8667 14.9083 17.75 16.025C16.6333 17.1417 15.2 18.4833 13.45 20.05L12 21.35Z",
    fill: "black"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDienTim);
export default __webpack_public_path__ + "static/media/dienTim.a8361ad77b3214a045c6b6d6e7fd75d7.svg";
export { ForwardRef as ReactComponent };